/**
 * What carries « your account is deleted » across the reload that ends a
 * deletion.
 *
 * Recette 2.2.11: after « Supprimer définitivement » the application reloaded
 * on the profile screen it was on, the guard sent the now anonymous visitor
 * to sign in with that screen as the return address, and nothing said the
 * account was gone. A tester read the white screen in between as a crash.
 *
 * The reload is kept, it is what empties every state at once. It now lands on
 * the first screen, and a mark in sessionStorage, written after the storage is
 * cleared, tells that screen to say the deletion went through. sessionStorage
 * because it survives a reload of the same tab and nothing longer: the next
 * launch of the app says nothing.
 */
export const THE_ACCOUNT_WAS_JUST_DELETED = 'theAccountWasJustDeleted';

/** Where a deletion lands: the first screen, with no return address. */
export const WHERE_A_DELETION_LANDS = '/auth/first';

/** Reads the mark once. A second visit to the screen says nothing. */
export const theAccountWasJustDeleted = (storage: Storage): boolean => {
  const marked = storage.getItem(THE_ACCOUNT_WAS_JUST_DELETED) === 'true';
  storage.removeItem(THE_ACCOUNT_WAS_JUST_DELETED);

  return marked;
};
